module.exports = __webpack_public_path__ + "img/stacked_area.d2fc083e.svg";